module.exports = __webpack_public_path__ + "static/img/1-1.80224f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/1-1.png
// module id = fxTY
// module chunks = 0